module.exports = __webpack_public_path__ + "static/media/icon-docs.92d01ce9.svg";